import { render, staticRenderFns } from "./PsUpperBar.vue?vue&type=template&id=39068e2b&scoped=true&"
import script from "./PsUpperBar.vue?vue&type=script&lang=js&"
export * from "./PsUpperBar.vue?vue&type=script&lang=js&"
import style0 from "./PsUpperBar.vue?vue&type=style&index=0&id=39068e2b&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39068e2b",
  null
  
)

export default component.exports